import {Routes} from '@angular/router'
import {DOCUMENT_PATH, LOGIN_PATH} from './application/types'
import {documentRoutes} from './document/document.routes'
import {ConfigService, LoginComponent} from '@sparbanken-syd/sparbanken-syd-bankid'
import {inject} from '@angular/core'

export const activate = () => {
  const service = inject(ConfigService)
  return service.accessToken !== null
}

export const routes: Routes = [
  {
    path: DOCUMENT_PATH,
    children: documentRoutes,
    canActivate: [activate]
  },
  {
    path: LOGIN_PATH,
    component: LoginComponent
  },
  {
    path: '**',
    redirectTo: LOGIN_PATH
  }
]
